import React from 'react';
import { Container } from 'components/UI';

import * as styles from './QuickFacts.module.scss';

export default function QuickFacts({ items }) {
  return (
    <Container id="quickFacts" className={styles.container}>
      <div className={styles.layout}>
        <div className={styles.wrapper}>
          {items.map(({ count, description }, i) => (
            <div key={`${description}-${i}`} className={styles.item}>
              <div className={styles.count}>{count}</div>
              <div>{description}</div>
            </div>
          ))}
        </div>
      </div>
    </Container>
  );
}
